import { render, staticRenderFns } from "./TopDonation.vue?vue&type=template&id=400be467"
import script from "./TopDonation.vue?vue&type=script&lang=js"
export * from "./TopDonation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports